import $ from "jquery";

const validators = {
    select: {
        parameters: ["search"],
        isValid: function (value, element, params) {
            if (params.search == "true") {
                var list = [];
                var listElement = $("#" + element.id + "_SearchList");
                listElement.children().each(function () {
                    list.push($(this).text());
                });

                return value == "" || list.includes(value);
            }

            return true;
        },
        unpack: function (options) {
            options.rules["select"] = options.params;
            options.messages["select"] = options.message;
        }
    }
};

function setupSelect() {
    $('[id$="_SearchList"]').each(function () {
        var inputElem = $("#" + this.id.replace("_SearchList", ""));
        var listElement = $(this);
        var listChildren = listElement.children('.list-group-item');

        inputElem.on("focus", function () {
            listElement.fadeIn("quick");
            filterListElements(listChildren, inputElem.val().toLowerCase())
        })

        inputElem.on("focusout", function () {
            listElement.fadeOut("quick");
        })

        inputElem.on("input", function (event) {
            filterListElements(listChildren, event.target.value.toLowerCase())
        })

        listChildren.on("mousedown ", function () {
            inputElem.val($(this).text());
        })
    })
}

function filterListElements(listElements, value) {
    listElements.each(function () {
        if ($(this).text().toLowerCase().includes(value)) {
            $(this).removeClass("d-none");
        } else {
            $(this).addClass("d-none");
        }
    })
}

export { validators, setupSelect };